export const DEFAULT_SITE_NAVIGATION = {
  conference_menu_title: 'Conferences',
  past_conferences_title: 'Past Conferences',
  workshops_title: 'Workshops and Training',
  publications_title: 'Publications',
  current_conferences: [
    { label: 'CPSI 2027', url: '/CPSI2027/', visible: true, home_visible: true, sort_order: 10 },
  ],
  past_conferences: [
    { label: 'CPSI 2026', url: '/CPSI2026/', visible: true, home_visible: true, sort_order: 10 },
    { label: 'CPSI 2025', url: '/CPSI2025/', visible: true, home_visible: true, sort_order: 20 },
    { label: 'ICCSI 2024', url: '/iccsi2024/', visible: true, home_visible: true, sort_order: 30 },
    { label: 'ICCSI 2023', url: '/iccsi2023/', visible: true, home_visible: false, sort_order: 40 },
    { label: 'ICCSI 2022', url: '/iccsi2022/', visible: true, home_visible: false, sort_order: 50 },
    { label: 'ICCSI 2021', url: '/iccsi2021/', visible: true, home_visible: true, sort_order: 60 },
  ],
  registration_link: { label: 'Registration Paper', url: '#/iccsireg', visible: true, sort_order: 100 },
  workshops: [
    { label: '2023 AUTUMN SCHOOL', url: '/iccsi2023/autumnSchoolCFP.html', visible: true, home_visible: true, sort_order: 10 },
    { label: '2022 AUTUMN SCHOOL', url: '/iccsi2022/autumnSchoolCFP.html', visible: true, home_visible: true, sort_order: 20 },
    { label: '2021 WINTER SCHOOL', url: '/iccsi2021/winterSchoolCFP.html', visible: true, home_visible: true, sort_order: 30 },
  ],
  publications: [
    { label: 'Journal of Cyber-Physical-Social Intelligence', url: 'http://cpsi.agist.org', visible: true, home_visible: true, sort_order: 10 },
    { label: 'Journal of Command and Control', url: 'http://journalcc.net', visible: true, home_visible: true, sort_order: 20 },
  ],
};

function normalizeItem(item, fallbackOrder = 0) {
  const label = String(item?.label || '').trim();
  const url = String(item?.url || '').trim();
  if (!label || !url) return null;
  return {
    label,
    url,
    visible: item.visible !== false && item.visible !== 0 && item.visible !== '0',
    home_visible: item.home_visible !== false && item.home_visible !== 0 && item.home_visible !== '0',
    sort_order: Number(item.sort_order ?? fallbackOrder) || 0,
  };
}

function normalizeItems(items, fallbackItems) {
  const source = Array.isArray(items) ? items : fallbackItems;
  return source
    .map((item, index) => normalizeItem(item, (index + 1) * 10))
    .filter(Boolean)
    .sort((a, b) => a.sort_order - b.sort_order || a.label.localeCompare(b.label));
}

export function normalizeSiteNavigation(input = {}) {
  const registrationLink = normalizeItem(input.registration_link, 100) || DEFAULT_SITE_NAVIGATION.registration_link;
  return {
    conference_menu_title: String(input.conference_menu_title || DEFAULT_SITE_NAVIGATION.conference_menu_title).trim(),
    past_conferences_title: String(input.past_conferences_title || DEFAULT_SITE_NAVIGATION.past_conferences_title).trim(),
    workshops_title: String(input.workshops_title || DEFAULT_SITE_NAVIGATION.workshops_title).trim(),
    publications_title: String(input.publications_title || DEFAULT_SITE_NAVIGATION.publications_title).trim(),
    current_conferences: normalizeItems(input.current_conferences, DEFAULT_SITE_NAVIGATION.current_conferences),
    past_conferences: normalizeItems(input.past_conferences, DEFAULT_SITE_NAVIGATION.past_conferences),
    registration_link: registrationLink,
    workshops: normalizeItems(input.workshops, DEFAULT_SITE_NAVIGATION.workshops),
    publications: normalizeItems(input.publications, DEFAULT_SITE_NAVIGATION.publications),
  };
}

export function publicNavigationItems(items) {
  return (items || []).filter((item) => item.visible !== false);
}

export function homeNavigationItems(items) {
  return publicNavigationItems(items).filter((item) => item.home_visible !== false);
}

export async function fetchSiteNavigation() {
  const response = await fetch('./api/site_navigation.php', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('site navigation api failed');
  }
  const data = await response.json();
  return normalizeSiteNavigation(data.navigation || {});
}
